export default __webpack_public_path__ + "static/media/check_icon.e449949f.svg";